import React from 'react'
import './Loader.css'
function Loader() {
  return (
    <div>
        <main>
	<div class="tower">
		<div class="tower__group">
			<div class="tower__brick-layer tower__brick-layer--4">
				<div class="tower__brick tower__brick--0">
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-stud"></div>
					<div class="tower__brick-stud"></div>
				</div>
				<div class="tower__brick tower__brick--90 tower__brick--red">
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-stud"></div>
					<div class="tower__brick-stud"></div>
				</div>
				<div class="tower__brick tower__brick--180 tower__brick--orange">
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-stud"></div>
					<div class="tower__brick-stud"></div>
				</div>
				<div class="tower__brick tower__brick--270 tower__brick--purple">
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-stud"></div>
					<div class="tower__brick-stud"></div>
				</div>
			</div>
			<div class="tower__brick-layer tower__brick-layer--3">
				<div class="tower__brick tower__brick--45 tower__brick--magenta">
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-stud"></div>
					<div class="tower__brick-stud"></div>
				</div>
				<div class="tower__brick tower__brick--135">
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-stud"></div>
					<div class="tower__brick-stud"></div>
				</div>
				<div class="tower__brick tower__brick--225 tower__brick--green">
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-stud"></div>
					<div class="tower__brick-stud"></div>
				</div>
				<div class="tower__brick tower__brick--315 tower__brick--orange">
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-stud"></div>
					<div class="tower__brick-stud"></div>
				</div>
			</div>
			<div class="tower__brick-layer tower__brick-layer--2">
				<div class="tower__brick tower__brick--0 tower__brick--red">
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-stud"></div>
					<div class="tower__brick-stud"></div>
				</div>
				<div class="tower__brick tower__brick--90 tower__brick--green">
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-stud"></div>
					<div class="tower__brick-stud"></div>
				</div>
				<div class="tower__brick tower__brick--180 tower__brick--purple">
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-stud"></div>
					<div class="tower__brick-stud"></div>
				</div>
				<div class="tower__brick tower__brick--270">
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-stud"></div>
					<div class="tower__brick-stud"></div>
				</div>
			</div>
			<div class="tower__brick-layer tower__brick-layer--1">
				<div class="tower__brick tower__brick--45 tower__brick--purple">
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-stud"></div>
					<div class="tower__brick-stud"></div>
				</div>
				<div class="tower__brick tower__brick--135 tower__brick--magenta">
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-stud"></div>
					<div class="tower__brick-stud"></div>
				</div>
				<div class="tower__brick tower__brick--225 tower__brick--red">
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-stud"></div>
					<div class="tower__brick-stud"></div>
				</div>
				<div class="tower__brick tower__brick--315 tower__brick--green">
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-stud"></div>
					<div class="tower__brick-stud"></div>
				</div>
			</div>
			<div class="tower__brick-layer">
				<div class="tower__brick tower__brick--0 tower__brick--move14">
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-stud"></div>
					<div class="tower__brick-stud"></div>
				</div>
				<div class="tower__brick tower__brick--90 tower__brick--red tower__brick--move13">
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-stud"></div>
					<div class="tower__brick-stud"></div>
				</div>
				<div class="tower__brick tower__brick--180 tower__brick--orange tower__brick--move16">
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-stud"></div>
					<div class="tower__brick-stud"></div>
				</div>
				<div class="tower__brick tower__brick--270 tower__brick--purple tower__brick--move15">
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-stud"></div>
					<div class="tower__brick-stud"></div>
				</div>
			</div>
			<div class="tower__brick-layer tower__brick-layer---1">
				<div class="tower__brick tower__brick--45 tower__brick--move10 tower__brick--magenta">
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-stud"></div>
					<div class="tower__brick-stud"></div>
				</div>
				<div class="tower__brick tower__brick--135 tower__brick--move9">
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-stud"></div>
					<div class="tower__brick-stud"></div>
				</div>
				<div class="tower__brick tower__brick--225 tower__brick--green tower__brick--move12">
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-stud"></div>
					<div class="tower__brick-stud"></div>
				</div>
				<div class="tower__brick tower__brick--315 tower__brick--orange tower__brick--move11">
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-stud"></div>
					<div class="tower__brick-stud"></div>
				</div>
			</div>
			<div class="tower__brick-layer tower__brick-layer---2">
				<div class="tower__brick tower__brick--0 tower__brick--red tower__brick--move6">
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-stud"></div>
					<div class="tower__brick-stud"></div>
				</div>
				<div class="tower__brick tower__brick--90 tower__brick--green tower__brick--move5">
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-stud"></div>
					<div class="tower__brick-stud"></div>
				</div>
				<div class="tower__brick tower__brick--180 tower__brick--purple tower__brick--move8">
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-stud"></div>
					<div class="tower__brick-stud"></div>
				</div>
				<div class="tower__brick tower__brick--270 tower__brick--move7">
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-stud"></div>
					<div class="tower__brick-stud"></div>
				</div>
			</div>
			<div class="tower__brick-layer tower__brick-layer---3">
				<div class="tower__brick tower__brick--45 tower__brick--purple tower__brick--move2">
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-stud"></div>
					<div class="tower__brick-stud"></div>
				</div>
				<div class="tower__brick tower__brick--135 tower__brick--magenta tower__brick--move1">
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-stud"></div>
					<div class="tower__brick-stud"></div>
				</div>
				<div class="tower__brick tower__brick--225 tower__brick--red tower__brick--move4">
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-stud"></div>
					<div class="tower__brick-stud"></div>
				</div>
				<div class="tower__brick tower__brick--315 tower__brick--green tower__brick--move3">
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-side"></div>
					<div class="tower__brick-stud"></div>
					<div class="tower__brick-stud"></div>
				</div>
			</div>
		</div>
	</div>
</main>
    </div>
  )
}

export default Loader